import * as BootstrapModal from "@/shared/ui/bootstrapModal";
import {ErrorResponse} from "@/shared/timr";

export class IdentifierForgottenPage {

	constructor() {
		$("#email").focus();
		$("#identifierForgottenForm").submit(() => this.sendIdentifierForgottenForm());
	}

	private redirectToLogin() {
		window.location.href = "/timr/recording/recording.html";
	}

	private sendIdentifierForgottenForm() {
		$.ajax({
			url: "/timr/identifierForgotten.json",
			type: "POST",
			data: $("#identifierForgottenForm").serialize(),
			success: () => {
				BootstrapModal.info({
					title: "identifierForgotten.sent.header",
					message: "identifierForgotten.sent",
					buttons: [{
						text: "identifierForgotten.navigateToLogin",
						action: () => this.redirectToLogin()
					}]
				});
			},
			error: (response: ErrorResponse) => {
				if (response.responseJSON) {
					if (response.responseJSON.fieldErrors) {
						BootstrapModal.error({
							message: response.responseJSON.fieldErrors[0].message
						});
					} else {
						BootstrapModal.error({
							message: response.responseJSON.message
						});
					}
				}
			}
		});
		return false;
	}
}
